import React, { useContext, useEffect, useState, useMemo } from "react"
import { withRouter } from "react-router-dom"
import styled from "styled-components"
import { AuthContext } from "../../../../auth-context"
import Button from "../../../../components/button"
import { SelectUsers } from "../campaign/select-users"
import { getHqChallenges, addHqChallengeParticipant, deleteHqChallengeParticipant } from '../../../../api'
import { Row, Action } from '../../../../components/action-button'
import CircularProgress from '@material-ui/core/CircularProgress'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import SearchIcon from '@material-ui/icons/Search'

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`

const TableTitle = styled.h2`
  padding: 16px 0;
  margin: 0 auto;
  color: #555;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`

const TableContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`

const Table = styled.table`
  background: #fff;
  border-spacing: 0px;
  width: 100%;
`

const TableHead = styled.thead`
  color: #fff;
`

const TableBody = styled.tbody``

const TableHeadRow = styled.tr``

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${(props) => (props.bigWidth ? "160px" : "100px")};
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
`

const ButtonCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-size: 0.875rem;
  text-align: center;
  padding: 8px 12px;
  white-space: nowrap;

  button {
    background: ${(props) => props.theme.button.background};
    border: none;
    border-radius: ${(props) => props.theme.button.borderRadius};
    color: ${(props) => props.theme.button.color};
    cursor: pointer;
    font-family: ${(props) => props.theme.font.secondary};
    font-weight: 500;
    height: 36px;
    width: 100px;
    transition: 0.2s ease opacity;
    &:hover {
      opacity: 0.8;
    }
  }
`

const HqChallenge = (props) => {
  const challengeId = Number(props.match.params.id)
  const { user } = useContext(AuthContext)
  const [hqChallengesState, updateHqChallengesState] = useState(0)
  const [hqChallenges, updateHqChallenges] = useState(null)
  const [show, setShow] = useState(false)

  const fetchHqChallenges = useMemo(() => {
    updateHqChallengesState(1)
    return getHqChallenges(user.id).then((res) => {
      updateHqChallenges(res.data.hq_challenges)
      updateHqChallengesState(2)
    })
  }, [updateHqChallengesState, updateHqChallenges, user.id])

  const challenge = useMemo(() => {
    let result = null
    if (hqChallengesState === 2) {
      for (let n = 0; n < hqChallenges.length; ++n) {
        if (hqChallenges[n].id === challengeId) {
          result = hqChallenges[n]
          break
        }
      }
    }
    return result
  }, [hqChallengesState, hqChallenges, challengeId])

  useEffect(() => {
    if (hqChallengesState === 0 && user.id) {
      fetchHqChallenges()
    }
  }, [hqChallengesState, user.id, fetchHqChallenges])

  const handleSubmit = (selected) => {
    addHqChallengeParticipant(user.id, challengeId, selected)
      .then((r) => {
        let newHqChallenges = []
        for (let n = 0; n < hqChallenges.length; ++n) {
          if (hqChallenges[n].id !== challengeId) {
            newHqChallenges.push(hqChallenges[n])
          } else {
            let newClientIdList = challenge.client_id_list.slice()
            for (let m = 0; m < selected.length; ++m) {
              newClientIdList.push(selected[m])
            }
            newHqChallenges.push({...challenge, client_id_list: newClientIdList})
          }
        }
        updateHqChallenges(newHqChallenges)
        setShow(false)
      })
      .catch((err) => {
        console.log(err);
      })
  }
  const handleDelete = (accountId) => {
    deleteHqChallengeParticipant(user.id, challengeId, accountId)
      .then(function (response) {
        let newHqChallenges = []
        for (let n = 0; n < hqChallenges.length; ++n) {
          if (hqChallenges[n].id !== challengeId) {
            newHqChallenges.push(hqChallenges[n])
          } else {
            let newClientIdList = []
            for (let m = 0; m < challenge.client_id_list.length; ++m) {
              if (challenge.client_id_list[m] !== accountId) {
                newClientIdList.push(challenge.client_id_list[m])
              }
            }
            newHqChallenges.push({...challenge, client_id_list: newClientIdList})
          }
        }
        updateHqChallenges(newHqChallenges)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  }
  let currentSelected = []
  if (challenge && user) {
    user.accounts.forEach((a) => {
      const thisClient = {
        id: a.id,
        email_address: a.email_address,
        name: a.name,
        claimed: a.claimed,
      }
      if (challenge.client_id_list.includes(a.id)) {
        currentSelected.push(thisClient)
      }
    })
  }

  return challenge === null ? (
    <Container>
      <CircularProgress size={32} />
    </Container>
  ) : (
    <>
      <Container>
        <Button label="Add Clients to HQ Challenge" onClick={() => setShow(true)} />
        <TableTitle>{challenge.name}</TableTitle>
        <TableContainer>
          <Table>
            <TableHead>
              <TableHeadRow>
                <HeadCell>Email Address</HeadCell>
                <HeadCell>Full Name</HeadCell>
                <HeadCell>Claimed</HeadCell>
                <HeadCell>Actions</HeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {currentSelected.map((entry, index) => (
                <TableBodyRow key={entry.id}>
                  <DataCell>{entry.email_address}</DataCell>
                  <DataCell>{entry.name}</DataCell>
                  <DataCell>{entry.claimed === 1 ? "Yes" : "No"}</DataCell>
                  <ButtonCell>
                    <Row>
                      {entry.claimed === 1 && (
                        <Action
                          icon={<SearchIcon/>}
                          text="Inspect"
                          onClick={() => props.history.push(`/dashboard/inspect/${entry.id}/overview`)}
                        />
                      )}
                      <Action
                        icon={<DeleteIcon />}
                        iconColor='#da0f0f'
                        text="Delete"
                        onClick={() => handleDelete(entry.id)}
                      />
                    </Row>
                  </ButtonCell>
                </TableBodyRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <SelectUsers
        currentSelected={currentSelected}
        submit={handleSubmit}
        heading="Select clients to be added"
        open={show}
        onClose={() => setShow(false)}
      />
    </>
  )
}

export default withRouter(HqChallenge)
